import { EvidenceCollector } from "../../core/validation/evidence-collector.js";
import { QualityGuard } from "../../core/validation/quality-guard.js";
import { ValidationPlanner } from "../../core/validation/validation-planner.js";
import { buildDeliverySummary, formatDeliverySummary } from "../../core/validation/canonical-finalization.js";

export interface CollectEvidenceOptions {
  cwd: string;
  exitOnError?: boolean;
  taskSlug?: string | null;
  mode?: string | null;
  evidencePolicy?: "optional" | "required" | null;
  dryRun?: boolean;
  profile?: string;
  branchRecovery?: string;
  userRequest?: string | null;
  explicitApprovals?: string[];
  visualDist?: string | null;
  port?: number | string | null;
}

/**
 * @deprecated Boundary helper to translate legacy CLI mode options to modern policies.
 */
export function resolvePoliciesFromLegacyMode(mode: string | null, evidencePolicy: "optional" | "required" | null): {
  evidencePolicy: "optional" | "required";
  riskLevel: "low" | "medium" | "high";
} {
  const activePolicy = evidencePolicy || (mode === "full" ? "required" : "optional");
  
  let risk: "low" | "medium" | "high" = "medium";
  if (mode === "full") {
    risk = "high";
  } else if (mode === "quick") {
    risk = activePolicy === "required" ? "medium" : "low";
  } else if (activePolicy === "required") {
    risk = "high";
  }
  
  return { evidencePolicy: activePolicy, riskLevel: risk };
}

export async function runCollectEvidence({
  cwd, exitOnError = true, taskSlug = null, mode = null, evidencePolicy = null, dryRun = false, profile = "generic", branchRecovery = "NOT_RECORDED", userRequest = null, explicitApprovals = [], visualDist = null, port = null
}: CollectEvidenceOptions): Promise<any> {
  const policies = resolvePoliciesFromLegacyMode(mode, evidencePolicy);
  const qualityGuard = new QualityGuard({ cwd, taskSlug, evidencePolicy: policies.evidencePolicy, riskLevel: policies.riskLevel });
  const planner = new ValidationPlanner({ cwd, qualityGuard });
  const tasks = await planner.plan(profile);

  const persist = !dryRun && policies.evidencePolicy === "required";
  const collector = new EvidenceCollector({
    cwd,
    timeout: 60000,
    taskSlug,
    evidencePolicy: policies.evidencePolicy,
    profile,
    branchRecovery,
    userRequest,
    explicitApprovals,
    visualDist,
    port: port || 8080
  });
  const evidence = await collector.collect(tasks, { writeArtifact: persist });
  const summary = buildDeliverySummary({ evidence });

  console.log("\n--- Delivery Summary ---");
  console.log(formatDeliverySummary(summary));
  console.log(persist ? "\nArtifact: EVIDENCE.json" : "\nArtifact: NOT_REQUIRED for optional evidence policy");
  console.log(`Commands processed: ${evidence.commands.length}\n`);

  if (evidence.status === "BLOCKED" && exitOnError) process.exit(1);
  return evidence;
}
